import React, { useEffect, useState, useContext } from "react";
import {
  MdBolt,
  MdSpeed,
  MdRoute,
  MdAutoAwesome,
} from "react-icons/md";
import voyahIcon from "../../../../assets/icons/voyahfree/voyah.png";
import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";
import "./VoyahFreeExtras.css";

const CARD_ICONS = [MdBolt, MdSpeed, MdRoute, voyahIcon];

const VoyahFreeExtras = () => {
  const { currentLang } = useContext(LanguageContext);

  const [extras, setExtras] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadExtras = async () => {
      try {
        setLoading(true);
        const response = await getPageContent("voyahfree", currentLang);
        setExtras(response.sections?.extras || null);
      } catch (err) {
        console.error("Failed to load Voyah Free extras", err);
      } finally {
        setLoading(false);
      }
    };

    loadExtras();
  }, [currentLang]);

  if (loading || !extras) return null;

  const cards = [1, 2, 3, 4]
    .map((n) => ({
      title: extras[`feature_${n}_title`],
      description: extras[`feature_${n}_description`],
    }))
    .filter((card) => card.title || card.description);

  return (
    <section className="vf-extras">
      <div className="vf-container">
        <div className="vf-header">
          {extras.title ? <h2 className="vf-title">{extras.title}</h2> : null}
          {extras.subtitle ? (
            <p className="vf-subtitle">{extras.subtitle}</p>
          ) : null}
        </div>

        <div className="vf-grid">
          {cards.map((card, index) => {
            const Icon = CARD_ICONS[index];
            const isPngIcon = Icon === voyahIcon;

            return (
              <div key={index} className="vf-card">
                {isPngIcon ? (
                  <img
                    src={voyahIcon}
                    alt="Voyah Free Icon"
                    className="vf-icon vf-png-icon"
                  />
                ) : (
                  <Icon className="vf-icon" />
                )}
                {card.title ? <h3>{card.title}</h3> : null}
                {card.description ? <p>{card.description}</p> : null}
              </div>
            );
          })}
        </div>

        {extras.positioning_line ? (
          <div className="vf-positioning">
            <MdAutoAwesome className="vf-position-icon" />
            <div className="vf-position-text">
              <span>{extras.positioning_line}</span>
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
};

export default VoyahFreeExtras;
